import { useController } from "react-hook-form";

import { FieldWrapper } from "../FieldWrapper/FieldWrapper";
import { NumberStepperField, NumberStepperFieldProps } from "./NumberStepperField";

interface FormNumberStepperProps
    extends Pick<
        NumberStepperFieldProps,
        "helperText" | "isMaxDisabled" | "isMinDisabled" | "label" | "max" | "step" | "name"
    > {
    defaultValue?: number;
    editable?: boolean;
    min?: number;
}

export function FormNumberStepper({
    defaultValue = 0,
    editable,
    helperText,
    isMaxDisabled,
    isMinDisabled,
    label,
    max,
    min = 0,
    name,
    step,
}: FormNumberStepperProps) {
    const { field } = useController({
        name,
        defaultValue,
    });

    return (
        <FieldWrapper name={field.name}>
            <NumberStepperField
                editable={editable}
                helperText={helperText}
                inputRef={field.ref}
                isMaxDisabled={isMaxDisabled}
                isMinDisabled={isMinDisabled}
                label={label}
                max={max}
                min={min}
                name={field.name}
                onChange={field.onChange}
                step={step}
                value={field.value}
            />
        </FieldWrapper>
    );
}
